(() => {
  'use strict';
  const root = document.querySelector('#rd-device-landing');
  if (!root) return;
  const isCnc = root.dataset.collectionUrl.includes('/cnc-plc-batteries-programmable-logic-control');
  const guidance = root.querySelector('[data-device-guidance]');
  if (guidance) {
    guidance.querySelectorAll('select[onchange]').forEach(select => {
      select.removeAttribute('onchange');
      select.addEventListener('change', () => {
        try {
          const url = new URL(select.value, location.origin);
          if (select.value && url.origin === location.origin && /^\/(collections|products)\//.test(url.pathname)) {
            if (isCnc && /fanuc/i.test(url.pathname)) location.assign(root.dataset.collectionUrl + '?rd_manufacturer=fanuc#rd-device-find');
            else location.assign(url.href);
          }
        } catch {}
      });
    });
  }
  const form = root.querySelector('[data-device-form]');
  if (!form) return;
  const query = form.elements.query, brand = form.elements.brand, sort = form.elements.sort;
  const cards = root.querySelector('[data-device-products]');
  const status = root.querySelector('[data-device-status]');
  const pagination = root.querySelector('[data-device-pagination]');
  const more = root.querySelector('[data-device-more]');
  const submit = form.querySelector('[type=submit]');
  const strings = JSON.parse(root.querySelector('[data-device-strings]').textContent);
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency });
  const tags = JSON.parse(root.dataset.tags || 'null') || [];
  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const manufacturerName = value => isCnc && /^(?:ge|generalelectric|(?:ge)?fanuc(?:cncplc)?|gefanucfanuc)$/.test(normalize(value)) ? 'GE Fanuc / Fanuc' : value;
  const textOnly = value => { const doc = new DOMParser().parseFromString(value || '', 'text/html'); return doc.body.textContent || ''; };
  const manufacturers = new Set();
  if (guidance) guidance.querySelectorAll('select option[value], .rd-category-links a').forEach(item => {
    if (/\/collections\//.test(item.value || item.getAttribute('href') || '')) {
      const value = item.textContent.trim();
      if (value && value.length < 70) manufacturers.add(value);
    }
  });
  const names = [...manufacturers].sort((a, b) => b.length - a.length);
  const normTags = tags.map(normalize);
  let catalog, loading, matches = [], limit = 24, timer;
  function prepare(product, index) {
    const productTags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(t => t.trim());
    if (!normTags.every(tag => productTags.some(t => normalize(t) === tag))) return null;
    let search = normalize([product.title, product.vendor, textOnly(product.body_html), ...productTags, ...(product.variants || []).map(v => v.sku)].join(' '));
    const supplied = productTags.find(tag => tag.startsWith('Equipment Manufacturer: '));
    let equipmentBrand = supplied ? supplied.slice(24) : names.find(name => normalize(product.title).startsWith(normalize(name)) || productTags.some(t => normalize(t) === normalize(name))) || product.vendor;
    if (isCnc && (/\b(?:ge[\s-]*)?fanuc\b/i.test(product.title) || productTags.some(tag => /^(?:Equipment Manufacturer: )?(?:GE[\s-]*)?Fanuc(?:[\s-]+CNC[\s-]+PLC)?$/i.test(tag)))) equipmentBrand = 'GE Fanuc / Fanuc';
    equipmentBrand = manufacturerName(equipmentBrand);
    if (equipmentBrand === 'GE Fanuc / Fanuc') search += normalize('GE Fanuc Fanuc');
    const prices = product.variants.map(v => Number(v.price)).filter(Number.isFinite);
    return { ...product, equipmentBrand, search, price: Math.min(...prices), priceVaries: new Set(prices).size > 1, index };
  }
  const availableBrands = new Set();
  Array.from(brand.options || []).forEach(option => {
    if (!option.value) return;
    const value = manufacturerName(option.value);
    if (availableBrands.has(value)) { option.remove(); return; }
    option.value = value; option.textContent = value; availableBrands.add(value);
  });
  function addBrands(values) {
    values.map(manufacturerName).filter(Boolean).sort((a, b) => a.localeCompare(b)).forEach(value => {
      if (!availableBrands.has(value)) { availableBrands.add(value); brand.add(new Option(value, value)); }
    });
    if (isCnc) {
      const selected = brand.value;
      const options = Array.from(brand.options || brand.children);
      brand.replaceChildren(...options.filter(option => !option.value), ...options.filter(option => option.value).sort((a, b) => a.textContent.localeCompare(b.textContent, undefined, { sensitivity: 'base', numeric: true })));
      brand.value = selected;
    }
  }
  addBrands(names);
  if (isCnc) addBrands(['GE Fanuc / Fanuc']);
  const initialManufacturer = new URLSearchParams(location.search).get('rd_manufacturer');
  if (isCnc && /^(gefanuc|fanuc)$/i.test(initialManufacturer || '')) brand.value = 'GE Fanuc / Fanuc';
  brand.disabled = false;
  async function loadCatalog() {
    if (catalog) return catalog;
    if (loading) return loading;
    loading = (async () => {
      const all = [], seen = new Set();
      async function page(number) {
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        const response = await fetch(root.dataset.collectionUrl + '?view=rd-finder-data&page=' + number + (preview ? '&preview_theme_id=' + encodeURIComponent(preview) : ''), { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
        if (!response.ok) throw new Error('Collection unavailable');
        const data = await response.json();
        if (!Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages < 0 || data.pages > 100 || data.page !== number) throw new Error('Invalid collection page');
        return data;
      }
      function append(batch) {
        for (const product of batch) {
          if (seen.has(product.id)) throw new Error('Repeated collection page');
          seen.add(product.id); all.push(product);
        }
        addBrands(batch.map((product, index) => prepare(product, index)).filter(Boolean).map(product => product.equipmentBrand));
      }
      const first = await page(1); append(first.products);
      for (let number = 2; number <= first.pages; number += 4) {
        const requests = [];
        for (let next = number; next <= Math.min(number + 3, first.pages); next++) requests.push(page(next));
        const batches = await Promise.all(requests);
        batches.forEach(batch => append(batch.products));
      }
      catalog = all.map(prepare).filter(Boolean);
      return catalog;
    })().catch(error => { loading = null; throw error; });
    return loading;
  }
  function element(tag, className, text) {
    const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node;
  }
  function draw() {
    const fragment = document.createDocumentFragment();
    matches.slice(0, limit).forEach(product => {
      const card = element('article', 'rd-lp-card');
      const url = '/products/' + encodeURIComponent(product.handle);
      const photo = element('a', 'rd-lp-image'); photo.href = url;
      const source = product.images?.[0]?.src;
      if (source && /^(https:)?\/\//.test(source)) { const img = element('img'); img.src = source; img.alt = product.title; img.loading = 'lazy'; img.width = 480; img.height = 480; photo.append(img); }
      const body = element('div', 'rd-lp-card-body');
      body.append(element('p', 'rd-lp-card-label', product.equipmentBrand || product.vendor));
      const heading = element('h3'), link = element('a', '', product.title); link.href = url; heading.append(link); body.append(heading);
      body.append(element('p', 'rd-lp-price', (product.priceVaries ? strings.from + ' ' : '') + money.format(product.price)));
      const detail = element('a', 'rd-lp-detail', strings.details + ' →'); detail.href = url; body.append(detail);
      card.append(photo, body); fragment.append(card);
    });
    if (!matches.length) fragment.append(element('p', 'rd-lp-empty', strings.empty));
    cards.replaceChildren(fragment); status.textContent = strings.results + ' (' + matches.length + ')';
    pagination.hidden = true; more.hidden = matches.length <= limit;
  }
  function apply(jump) {
    const words = query.value.trim().split(/\s+/).map(normalize).filter(Boolean);
    matches = catalog.filter(p => (!brand.value || manufacturerName(p.equipmentBrand) === manufacturerName(brand.value)) && words.every(word => p.search.includes(word) || (/^(cs|rd)/.test(word) && p.search.includes(word.replace(/^(cs|rd)/, word.startsWith('cs') ? 'rd' : 'cs')))));
    if (sort.value === 'price-low') matches.sort((a, b) => a.price - b.price);
    else if (sort.value === 'price-high') matches.sort((a, b) => b.price - a.price);
    else if (sort.value === 'name') matches.sort((a, b) => a.title.localeCompare(b.title));
    limit = 24; draw();
    if (jump) { status.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); status.focus({ preventScroll: true }); }
  }
  async function search(jump) {
    submit.disabled = true; form.setAttribute('aria-busy', 'true'); status.textContent = strings.loading;
    try { await loadCatalog(); apply(jump); }
    catch { status.textContent = strings.failure; }
    finally { submit.disabled = false; form.removeAttribute('aria-busy'); }
  }
  form.addEventListener('submit', event => { event.preventDefault(); search(true); });
  form.addEventListener('focusin', () => { if (!catalog && !loading) search(false); }, { once: true });
  query.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => { if (catalog) apply(false); }, 180); });
  brand.addEventListener('change', () => search(false));
  sort.addEventListener('change', () => search(false));
  form.addEventListener('reset', () => { setTimeout(() => { if (catalog) apply(false); }, 0); });
  more.addEventListener('click', () => { limit += 24; draw(); });
  const warm = () => { if (!catalog && !loading) loadCatalog().then(() => { if (initialManufacturer) apply(false); }).catch(() => {}); };
  if (typeof IntersectionObserver !== 'undefined') {
    const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { warm(); observer.disconnect(); } }, { rootMargin: '600px' });
    observer.observe(form);
  } else { warm(); }

})();

